import { gql } from '@apollo/client';

const updatePlantNoteActiveMutation = gql`
    mutation updatePlantContentNote($id: Int!, $content: String) {
        update_plant_note_by_pk(pk_columns: { id: $id }, _set: { content: $content }) {
            id
        }
    }
`;

export default updatePlantNoteActiveMutation;
